import { render, staticRenderFns } from "./SupportMain.vue?vue&type=template&id=1454d365&"
import script from "./SupportMain.vue?vue&type=script&lang=js&"
export * from "./SupportMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1454d365')) {
      api.createRecord('1454d365', component.options)
    } else {
      api.reload('1454d365', component.options)
    }
    module.hot.accept("./SupportMain.vue?vue&type=template&id=1454d365&", function () {
      api.rerender('1454d365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/support/SupportMain.vue"
export default component.exports